import { render, staticRenderFns } from "./UserRetrievePassEmail.vue?vue&type=template&id=e64328ca&scoped=true"
import script from "./UserRetrievePassEmail.vue?vue&type=script&lang=js"
export * from "./UserRetrievePassEmail.vue?vue&type=script&lang=js"
import style0 from "./UserRetrievePassEmail.vue?vue&type=style&index=0&id=e64328ca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64328ca",
  null
  
)

export default component.exports